import { maybeSetupDevMenu, getMenuAPIStore, getMenuIndexStore } from '../devMenu';
import { filterActive, capitaliseFirstLetter } from '../utils';

const start = () => {
  const storeIndex = getMenuIndexStore();
  const storeAPI = getMenuAPIStore();
  const prodAPI = (i = storeIndex) =>
    `https://api.maps.service.nsw.gov.au/search/${i}?name=&category=&subcategory=&neLat=10.0&neLon=175.5&swLat=-57.2&swLon=89.7`;
  const stgAPI = (i = storeIndex) => `https://api.maps-stg.testservicensw.net/cache/${i}`;
  const devAPI = (i = storeIndex) => `https://dev-api.maps-dev.testservicensw.net/cache/${i}`;

  const viewport = document.querySelector('map-viewport');

  const fromLatLon = ({ lat, lon }) => ({ lat, lng: lon });
  const transformData = (d) => {
    console.log(d);
    return d.map(({ location, name, category, industryType, ...rest }) => ({
      ...fromLatLon(location),
      name: name.trim(),
      tags: industryType ? capitaliseFirstLetter(industryType) : [category],
      ...rest,
    }));
  };

  const fetchData = (url) => fetch(url).then((res) => res.json());
  const fetchDevCombinedData = () =>
    fetchData(devAPI('seniors')).then((d1) =>
      fetchData(devAPI('seniorscard')).then((d2) => [...d1, ...d2])
    );
  const fetchStgCombinedData = () =>
    fetchData(stgAPI('seniors')).then((d1) =>
      fetchData(stgAPI('seniorscard')).then((d2) => [...d1, ...d2])
    );
  const maybeFetchIndex = (url) =>
    (storeIndex === 'combined-dev' && fetchDevCombinedData()) ||
    (storeIndex === 'combined-stg' && fetchStgCombinedData()) ||
    fetchData(url);
  const setData = (d) => (console.dir(viewport), viewport.load(transformData(d)));
  const maybeProdData = () => {
    switch (storeAPI) {
      case 'prod':
        return maybeFetchIndex(prodAPI());
      case 'stg':
        return maybeFetchIndex(stgAPI());
      default:
        return maybeFetchIndex(devAPI());
    }
  };
  const maybeRows = (d) => d?.rows || d;

  const loadData = () =>
    maybeProdData() //
      .then(maybeRows)
      .then(filterActive)
      .then(setData);

  viewport.init('google', 'AIzaSyAbvtFai2_G3xh6p1NCFpOfxdqUstrXQzc').then(loadData);

  let footerExpanded = false;
  const footerButton = document.getElementById('FooterButton');
  const list = document.querySelector('.map-list-container');
  const footer = document.getElementById('FooterContainer');
  const viewportContainer = document.querySelector('.map-viewport-container');
  const recordCount = document.querySelector('.record-counts');

  footerButton.addEventListener('click', () => {
    footerExpanded = !footerExpanded;
    footer.style.bottom = footerExpanded ? 0 : '';
    footer.style.overflow = footerExpanded ? 'scroll' : 'hidden';
  });

  list.addEventListener('click', () => {
    setTimeout(() => {
      const closeButton = document.querySelector('map-selection button[close-button="true"]');
      const mapSelection = document.querySelector('map-selection');
      list.classList.add('mobile-hidden-by-selection');
      recordCount.classList.add('mobile-hidden-by-selection');
      mapSelection.scrollTop = 0;

      closeButton.addEventListener('click', () => {
        list.classList.remove('mobile-hidden-by-selection');
        recordCount.classList.remove('mobile-hidden-by-selection');
      });
    });
  });

  const selection = document.querySelector('map-selection');

  // Click phone number link
  selection.addEventListener('click-phone', ({ detail }) =>
    window.open(`tel:${detail.phone}`, '_self')
  );

  // Click webiste link
  selection.addEventListener('click-link', ({ detail }) => {
    window.open(detail.web, '_blank');
  });

  // Click get directions
  selection.addEventListener('click-directions', ({ detail }) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${detail.address}&travelmode=driving`
    );
  });
  // Click get directions
  viewport.addEventListener('click-directions', ({ detail }) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${detail.address}&travelmode=driving`
    );
  });

  const mapViewButton = document.getElementById('map-view-tab-button');
  const listViewButton = document.getElementById('list-view-tab-button');
  // Switch to map view
  mapViewButton.addEventListener('click', () => {
    viewportContainer.classList.remove('mobile-hidden-by-view');
    list.classList.add('mobile-hidden-by-view');
    mapViewButton.style.borderBottom = '2px solid red';
    listViewButton.style.borderBottom = 'medium none';
  });

  // Switch to list view
  listViewButton.addEventListener('click', () => {
    viewportContainer.classList.add('mobile-hidden-by-view');
    list.classList.remove('mobile-hidden-by-view');
    mapViewButton.style.borderBottom = 'medium none';
    listViewButton.style.borderBottom = '2px solid red';
  });
};
const maybeStart = () => (maybeSetupDevMenu() ? start() : document.querySelector('html').remove());
maybeStart();
